define('gaHandler',['jquery'],
    function ($) {
        var links = document.querySelectorAll('a[href$=".pdf"]');
        for (var index = 0; index < links.length; index++) {
            var element = links[index];
            trackPdf(element);
        }

        function trackPdf(element) {
            $(element).click(function (e) {
                e.preventDefault();
                var pdfUrl = decodeURI(element.href).split("/"),
                    pdfName = pdfUrl[pdfUrl.length - 1];
                if (window.ga && window.ga !== undefined) {
                    ga('send', 'event', 'pdfClick', 'clicked on pdf link', pdfName);
                }
                window.location.href = element.href;
            });
        }
    });



